import { useEffect, useState } from "react";
import firestoreService from "../../services/firestoreService";
import storageService from "../../services/storageService";
import { useParams } from "react-router-dom";
import { useAuth } from "../auth/useAuth";

function useLecturePreProblem(nav, onNavChangeHandler){
    const { id } = useParams();
    const { user } = useAuth();
    const [problem, setProblem] = useState({
        question: '',
        content: '',
        correct_answer: ''
    });
    const [canvasData, setCanvasData] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modalProps, setModalProps] = useState({
        title:"",
        message:"",
        confirmButtonName:"",
        cancelButtonName:"",
        onConfirm: null,
        onCancel: null,
    })


    const fetchLessonData = async() => {
        const data = await firestoreService.getDocument(`LectureProblem`, id);
        if(data.success){
            setProblem({
                question: data.data.question || '',
                content: data.data.content || '',
                correct_answer: data.data.correct_answer || ''
            });
            return;
        }
        setIsOpenModal(true);
        setModalProps({
            title:"에러",
            message:"강의 문제를 가져오는 중 오류가 발생하였습니다",
            confirmButtonName:"확인",
            onConfirmClick:() => setIsOpenModal(false)
        })
    }


    const fetchCanvasData = async() => {
        try {
            // 사용자 ID 확인
            const userId = user?.uid;
            if (!userId) return;

            // LectureProgress에서 캔버스 데이터 가져오기
            const docPath = `LectureProgress/${id}/LecturePreProblem`;
            const result = await firestoreService.getDocument(docPath, user.uid);
            
            if(result.success && result.data && result.data.canvas_data) {
                setCanvasData({ canvasData: result.data.canvas_data });
            } else {
                setCanvasData(null);
            }
        } catch (error) {
            setCanvasData(null);
        }
    }

    useEffect(() => {
        fetchLessonData();
    }, [id])

    // 사용자 인증 후 캔버스 데이터 불러오기
    useEffect(() => {
        if (user?.uid) {
            fetchCanvasData();
        }
    }, [user?.uid, id])

    // 캔버스 데이터 저장 (LectureProgress에 통합 저장)
    const saveCanvasData = async(canvasDataUrl) => {
        try {
            setIsSaving(true);
            
            // 사용자 ID 확인
            const userId = user?.uid;
            if (!userId) {
                throw new Error("사용자 인증이 필요합니다.");
            }

            // 기존 데이터가 있는지 확인
            const docPath = `LectureProgress/${id}/LecturePreProblem`;
            const existingData = await firestoreService.getDocument(docPath);
            
            let result;
            if (existingData.success && existingData.data) {
                // 기존 데이터가 있으면 업데이트
                result = await firestoreService.updateDocument(docPath, {
                    canvas_data: canvasDataUrl,
                    updated_at: new Date()
                });
            } else {
                // 기존 데이터가 없으면 새로 생성
                const preProblemData = {
                    canvas_data: canvasDataUrl,
                    registered_at: new Date(),
                    updated_at: new Date()
                };
                result = await firestoreService.createDocument(docPath, preProblemData, userId);
            }
            
            if(result.success) {
                setModalProps({
                    title: "성공",
                    message: "캔버스가 저장되었습니다.",
                    confirmButtonName: "확인",
                    onConfirm: () => setIsOpenModal(false)
                });
                setIsOpenModal(true);
            } else {
                throw new Error(result.error);
            }
        } catch (error) {
            setModalProps({
                title: "오류",
                message: "캔버스 저장 중 오류가 발생했습니다.",
                confirmButtonName: "확인",
                onConfirm: () => setIsOpenModal(false)
            });
            setIsOpenModal(true);
        } finally {
            setIsSaving(false);
        }
    }


    const submitPreProblemSolveData = async(canvasDataUrl = null) => {
        try {
            // 사용자 인증 확인
            if (!user?.uid) {
                setIsOpenModal(true);
                setModalProps({
                    title: "오류",
                    message: "사용자 인증이 필요합니다. 로그인을 다시 시도해주세요.",
                    confirmButtonName: "확인",
                    onConfirm: () => setIsOpenModal(false)
                });
                return;
            }

            // 캔버스 데이터가 제공되면 저장
            if (canvasDataUrl) {
                await saveCanvasData(canvasDataUrl);
            }
            
            const newNav = nav;
            newNav.completed = true;
            onNavChangeHandler(newNav);
        } catch (error) {
            setIsOpenModal(true);
            setModalProps({
                title: "오류",
                message: "사전 문제 제출 중 오류가 발생했습니다.",
                confirmButtonName: "확인",
                onConfirm: () => setIsOpenModal(false)
            });
            
            // 오류가 발생해도 제출은 진행
            const newNav = nav;
            newNav.completed = true;
            onNavChangeHandler(newNav);
        }
    }

    return {
        isOpenModal,
        modalProps,
        problem,
        canvasData,
        isSaving,
        saveCanvasData,
        fetchCanvasData,
        submitPreProblemSolveData
    }
}

export default useLecturePreProblem;